import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import {getRequest} from "@/api/api";
import AOS from 'aos';
import "../node_modules/aos/dist/aos.css"

Vue.prototype.getRequest = getRequest;

AOS.init({
  duration: 1000,
  easing: 'ease-in-out',
  once: true,
  disable: 'mobile'  
})


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
